import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { CALYPSO_LIGHT, EERIE, KOALA } from 'HubStyleTokens/colors';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import PortalIdParser from 'PortalIdParser';
import CallSettingsIcon from 'calling-ui-library/callee-select/components/CallSettingsIcon';
// @ts-expect-error module not typed
import CalleeObjectGroupOption from 'calling-ui-library/callee-select/components/CalleeObjectGroupOption';
// @ts-expect-error module not typed
import PhoneNumberOption from 'calling-ui-library/callee-select/components/PhoneNumberOption';
// @ts-expect-error module not typed

import { getPhoneNumberProperties, getValue } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { getFormattedName } from 'calling-lifecycle-internal/callees/operators/propertyValueGetters';
import { getAdditionalProperties } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getStandaloneConnectionId } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { sendReturnCallMessage } from '../../utils/sendReturnCallMessage';
import { callingTabUrl } from '../../utils/urls';
import { useFetchCallableObjectFromCallId } from '../hooks/useFetchCallableObjectFromCallId';
// @ts-expect-error module not typed
import CalleeSkeleton from 'calling-lifecycle-internal/skeleton-states/components/CalleeSkeleton';
import CallFromNumberAccordionItem from './CallFromNumberAccordionItem';
import { useCallFromNumberContext } from '../contexts/CallFromNumberContext';
import ReturnCallPopoverError from './ReturnCallPopoverError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ReturnCallPopover__Wrapper",
  componentId: "sc-11thurp-0"
})(["max-width:320px;max-height:400px;display:flex;"]);
const Options = styled.div.withConfig({
  displayName: "ReturnCallPopover__Options",
  componentId: "sc-11thurp-1"
})([".option-item:hover{background-color:", ";}"], CALYPSO_LIGHT);
const Footer = styled.div.withConfig({
  displayName: "ReturnCallPopover__Footer",
  componentId: "sc-11thurp-2"
})(["padding:12px 16px;border-style:solid;border-width:2px 0 0 0;border-color:", ";font-weight:", ";color:", ";"], KOALA, WEB_FONT_MEDIUM_WEIGHT, EERIE);
const ReturnCallPopover = ({
  callId,
  inboundCallOriginPhoneNumber,
  onClosePopover,
  setCallStarted
}) => {
  const {
    isLoading,
    callableObject,
    objectTypeId,
    error
  } = useFetchCallableObjectFromCallId({
    callId: Number(callId)
  });
  const {
    selectedFromNumber
  } = useCallFromNumberContext();
  const portalId = PortalIdParser.get();
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeConnectionId = getStandaloneConnectionId(widgetDetails);
  const handleReturnCall = useCallback(() => {
    if (!callId) {
      return;
    }
    setCallStarted(true);
    const selectedReturnCallFromNumber = selectedFromNumber && selectedFromNumber.get('phoneNumber') || '';
    const selectedFromNumberFriendlyName = selectedFromNumber && selectedFromNumber.get('nickname') || '';
    if (activeConnectionId) {
      sendReturnCallMessage({
        activeConnectionId: activeConnectionId,
        fromNumber: selectedReturnCallFromNumber,
        fromNumberFriendlyName: selectedFromNumberFriendlyName,
        toNumber: inboundCallOriginPhoneNumber,
        callId
      });
    } else {
      const queryString = `action=RETURN_CALL_MESSAGE&fromNumber=${selectedReturnCallFromNumber}&fromNumberFriendlyName=${selectedFromNumberFriendlyName}&toNumber=${inboundCallOriginPhoneNumber}&callId=${callId}`;
      window.open(callingTabUrl(portalId, queryString), 'calling-window', 'menubar=no,resizable=yes,scrollbars=no,location=no,width=740,height=750');
    }
    onClosePopover();
  }, [activeConnectionId, callId, selectedFromNumber, inboundCallOriginPhoneNumber, portalId, setCallStarted, onClosePopover]);
  const formattedName = useMemo(() => callableObject && getFormattedName(getAdditionalProperties(callableObject)), [callableObject]);
  const phoneNumberProperty = useMemo(() => {
    if (!callableObject) {
      return null;
    }
    const callableOptions = getPhoneNumberProperties(callableObject);
    return callableOptions.find(_phoneNumberProperty => {
      return getValue(_phoneNumberProperty) === inboundCallOriginPhoneNumber;
    });
  }, [callableObject, inboundCallOriginPhoneNumber]);
  return /*#__PURE__*/_jsx(Wrapper, {
    children: error || !callableObject ? /*#__PURE__*/_jsx(ReturnCallPopoverError, {
      error: error
    }) : isLoading ? /*#__PURE__*/_jsx(CalleeSkeleton, {
      className: "m-top-2 p-bottom-2"
    }) : callableObject && /*#__PURE__*/_jsxs(Options, {
      className: "flex-column m-top-2",
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-top-1",
        children: /*#__PURE__*/_jsx(CalleeObjectGroupOption, {
          callableObject: callableObject,
          objectTypeId: objectTypeId
        })
      }), /*#__PURE__*/_jsx(PhoneNumberOption, {
        className: "p-left-4",
        phoneNumberProperty: phoneNumberProperty,
        onSelect: handleReturnCall,
        callableObject: callableObject,
        disabled: false,
        OptionIcon: CallSettingsIcon,
        disabledTooltipMessage: undefined,
        formattedName: formattedName,
        objectTypeId: objectTypeId,
        hidePropertyName: true
      }), /*#__PURE__*/_jsx(CallFromNumberAccordionItem, {}), /*#__PURE__*/_jsx(Footer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "call-highlight-card.returnCall.footer"
        })
      })]
    })
  });
};
export default ReturnCallPopover;